(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opal-test-permeabilite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('opal-proof-player')) {
    customElements.define('opal-proof-player', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }
      initialize() {
        if (this.dataset.enhanced || !this.isConnected) return;
        const video = this.querySelector('video');
        const button = this.querySelector('.opal-p4__action');
        const label = this.querySelector('[data-opal-action]');
        const duration = this.querySelector('[data-opal-duration]');
        const error = this.querySelector('.opal-p4__error');
        if (!video || !button || !label) return;
        this.dataset.enhanced = '';
        button.hidden = false;
        const update = () => {
          const playing = !video.paused && !video.ended;
          this.toggleAttribute('data-playing', playing);
          label.textContent = playing ? 'Mettre en pause' : (video.ended ? 'Revoir le test' : (this.hasAttribute('data-started') ? 'Reprendre le test' : 'Voir le test'));
          if (playing) {
            this.dataset.started = '';
            video.controls = true;
            error.hidden = true;
          }
        };
        const fallback = () => {
          video.controls = true;
          this.dataset.started = '';
          error.hidden = false;
          update();
        };
        button.addEventListener('click', async () => {
          if (!video.paused && !video.ended) { video.pause(); return; }
          video.controls = true;
          if (video.ended) video.currentTime = 0;
          try { await video.play(); } catch (e) { fallback(); }
        });
        ['play', 'pause', 'ended'].forEach(name => video.addEventListener(name, update));
        video.addEventListener('error', fallback);
        video.addEventListener('loadedmetadata', () => {
          if (duration && Number.isFinite(video.duration)) {
            const seconds = Math.floor(video.duration);
            duration.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
          }
        });
        video.controls = false;
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
